import { useRef } from 'react';
import { Alert, Box, CircularProgress, Textarea, Typography } from '@mui/joy';
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import AttachFileRoundedIcon from '@mui/icons-material/AttachFileRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import InsertDriveFileRoundedIcon from '@mui/icons-material/InsertDriveFileRounded';

/** Draft is cleared by MessagesPane only after the server accepts the message. */
export default function MessageInput({ textAreaValue, setTextAreaValue, onSubmit, onAttach, attachments = [], onRemoveAttachment, sending = false, error }) {
  const fileInputRef = useRef(null);
  const canSend = Boolean(textAreaValue.trim() || attachments.length) && !sending;
  return (
    <Box className="lv-thread-composer-area">
      {error && <Alert color="danger" size="sm" sx={{ mb: 1, fontSize: 12 }}>{error}</Alert>}
      {attachments.length > 0 && <Box className="lv-thread-attachments" aria-label="Прикреплённые файлы">
        {attachments.map((file, index) => <Box className="lv-thread-file" key={`${file.name}-${file.size}-${index}`}>
          <InsertDriveFileRoundedIcon sx={{ fontSize: 16, color: 'inherit' }} />
          <span title={file.name}>{file.name}</span>
          <button type="button" disabled={sending} onClick={() => onRemoveAttachment?.(index)} aria-label={`Убрать файл ${file.name}`}><CloseRoundedIcon sx={{ fontSize: 15, color: 'inherit' }} /></button>
        </Box>)}
      </Box>}
      <Box className="lv-thread-composer">
        <input type="file" ref={fileInputRef} style={{ display: 'none' }} onChange={onAttach} multiple disabled={sending} />
        <button type="button" className="lv-thread-attach" onClick={() => fileInputRef.current?.click()} disabled={sending} aria-label="Прикрепить файл">
          <AttachFileRoundedIcon sx={{ fontSize: 22, color: 'inherit' }} />
        </button>
        <Textarea placeholder="Напишите сообщение…" aria-label="Сообщение" value={textAreaValue} disabled={sending}
          onChange={event => setTextAreaValue(event.target.value)} minRows={1} maxRows={5}
          onKeyDown={event => {
            if (event.key === 'Enter' && !event.shiftKey && !event.nativeEvent.isComposing && event.keyCode !== 229) {
              event.preventDefault();
              if (canSend) onSubmit();
            }
          }} variant="plain" sx={{ flex: 1, minWidth: 0, backgroundColor: 'transparent', '--Textarea-focusedThickness': '0px', '&::before': { display: 'none' }, px: 0.5, fontSize: 14, lineHeight: 1.6, py: 1 }} />
        <button type="button" className="lv-thread-send" onClick={onSubmit} disabled={!canSend} aria-label="Отправить сообщение">
          {sending ? <CircularProgress size="sm" sx={{ '--CircularProgress-size': '20px', color: 'inherit' }} /> : <SendRoundedIcon sx={{ fontSize: 21, color: 'inherit' }} />}
        </button>
      </Box>
      <Typography level="body-xs" className="lv-thread-keyboard-hint" sx={{ display: { xs: 'none', sm: 'block' } }}>Enter — отправить · Shift + Enter — новая строка</Typography>
    </Box>
  );
}
